// extracted by mini-css-extract-plugin
export default {"EmailVerification":"emailVerification_EmailVerification__GoOpY","input":"emailVerification_input__+lqDW"};